import { AppRouteProps } from "@bsm/component";
import { StudentDetailsAboutContainer } from "./container/StudentDetailsAboutContainer";

export const StudentDetailsAboutRoutes: Array<AppRouteProps> = [
    {
        path: "about",
        element: <StudentDetailsAboutContainer />,
    },
];